// 正式环境域名
const productionHost = '.zjsru.edu.cn'

// 通过地址获取域名
const host = location.host
const protocol = location.protocol + '//'
const hostDomain = host.substring(host.indexOf('.'))
// 考试
const UTEST_API_HOST = protocol + "ulearning" + hostDomain + "/utestapi"
const UTEST_WEB_HOST = protocol + 'ulearning' + hostDomain + "/utest"
// 文档预览
const DOCS_API_HOST = protocol + "ulearning" + productionHost + '/docs';
// "http://127.0.0.1:1111" ||
// 优学院
const COURSE_API_HOST = protocol + "ulearning" + hostDomain + "/api";
// 资源上传和访问
const UPLOAD_SERVER_HOST =  "ulearning" + productionHost + "/uobs1";
const UPLOAD_SERVER_PROTOCOL = protocol.indexOf("https") === 0 ? 'https' : 'http';
const RESOURCE_SERVER_HOST = protocol + "ulearning" + productionHost + "/uobs1" + "/view";
// UA课件
const UA_API_HOST = protocol + "ulearning" + hostDomain + "/uaapi";
// 1.0页面及接口地址
const UMOOC_API_HOST = protocol + "ulearning" + hostDomain;
// 移动端H5
const UMOBILE_WEB_HOST = protocol + "ulearning" + hostDomain + "/mobile";
// 知识图谱
const KG_API_HOST = protocol + 'ulearning' + hostDomain + "/knowledgeapi"
// 作业
const HOMEWORK_API_HOST = protocol + 'ulearning' + hostDomain + "/homeworkapi"

// 知识图谱
export default {
  hostDomain,
  API_HOST: COURSE_API_HOST,
  COURSE_API_HOST,
  KG_API_HOST,
  TEST_API_HOST: HOMEWORK_API_HOST,
  UTEST_WEB_HOST,
  UTEST_API_HOST,
  UA_API_HOST,
  RESOURCE_SERVER_HOST,
  DOCS_HOST: DOCS_API_HOST,  
  UMOBILE_HOST: UMOBILE_WEB_HOST,
  UMOOC_SERVER_HOST: UMOOC_API_HOST,
  UPLOAD_SERVER_HOST,
  UPLOAD_SERVER_PROTOCOL
}
  
  
  